
import React from 'react'

export class BarCharts extends React.Component {

  render(){
    let ratings = this.props.ratings
    ratings.sort((a, b) => parseInt(b.rating) - parseInt(a.rating));  // makes sure that 5 star comes first
    let ratingsHTML = ratings.map(function(ratingObj){
      let rating = ratingObj.rating
      let ratingCount = ratingObj.count
      let ratingCountDisplay = ratingCount.toLocaleString('en-US')
      return (
        <div key={rating} className="reviews_percentage_bar_container">
          <div className="reviews_percentage_label">
            <label>{rating} Star</label>
          </div>
          <div className="reviews_percentage_bar">
            <div className="bar_background">
              <div className="bar_fill" style={{'width': (ratingCount * 100.0/this.props.totalCount).toString() + "%"}}>
              </div>
            </div>
          </div>
          <div className="reviews_percentage_count">
            <span className="count">{ratingCountDisplay}</span>
          </div>
        </div>
      )
    }.bind(this))
    return (
      <div className="reviews_stats">
        <div className="reviews_percentage_bars">
          {ratingsHTML}
        </div>
      </div>
    )
  }
}
